import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
type CountdownTimerProps = {
  label?: string;
  compact?: boolean;
};
export function CountdownTimer({
  label,
  compact = false
}: CountdownTimerProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units: Array<{
    value: string;
    unit: string;
  }> = [{
    value: hours,
    unit: 'HS'
  }, {
    value: minutes,
    unit: 'MIN'
  }, {
    value: seconds,
    unit: 'SEG'
  }];
  const box = compact ? 'min-w-[52px] px-2 py-1.5 text-xl' : 'min-w-[74px] px-3 py-2.5 text-3xl sm:text-4xl';
  return <div className="flex flex-col items-center gap-3" data-id="element-53" data-mp="1fdww0bma4go1">
      {label ? <p className="text-center text-xs font-bold uppercase tracking-[0.2em] text-gold-400" data-id="element-54" data-mp="1adimsq8xz0of">
          {label}
        </p> : null}
      <div className="flex items-start gap-2" role="timer" aria-live="off" data-id="element-55" data-mp="15g0mtpcwjvsk">
        {units.map((u, i) => <React.Fragment key={u.unit} data-id="element-56" data-mp="2zrnnvtme0she" data-mpi={i}>
            <div className="flex flex-col items-center gap-1" data-id="element-57" data-mp="2zsyue177wec7">
              <span className={`flex items-center justify-center rounded-xl border border-gold-500/30 bg-ink-950 font-display tabular-nums text-cream ${box}`} data-id="element-58" data-mp="1c0ydfz3exits">
                {u.value}
              </span>
              <span className="text-[10px] font-semibold tracking-[0.18em] text-cream/45" data-id="element-59" data-mp="123sniu6jbxv5">
                {u.unit}
              </span>
            </div>
            {i < units.length - 1 ? <span aria-hidden="true" className={`font-display text-gold-500/60 ${compact ? 'text-lg leading-8' : 'text-3xl leading-[3.25rem] sm:text-4xl'}`} data-id="element-60" data-mp="1us7t6q3s13tt">
                :
              </span> : null}
          </React.Fragment>)}
      </div>
    </div>;
}